import axios from "axios";

import { store } from "../Redux/store";
import { logout } from "../Redux/userSlice";

const newRequest = axios.create({
  baseURL: "https://drmath.co/backend/public/api",
  headers: {
    "Content-Type": "application/json",
    "Accept-Language": "ar",
  },
});

// Request interceptor - adds authorization token
newRequest.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handles unauthenticated responses
newRequest.interceptors.response.use(
  (response) => {
    // Successfully processed response
    return response;
  },
  (error) => {
    // Check if we got an unauthenticated response
    if (
      error.response &&
      (error.response.status === 401 ||
        (error.response.data &&
          error.response.data.message === "Unauthenticated."))
    ) {
      // Dispatch the logout action to update Redux state
      store.dispatch(logout());

      // Clear localStorage
      localStorage.removeItem("user");

      // Optionally: Redirect to login page
      // window.location.href = "/login";
    }

    // Return the error to continue the promise chain
    return Promise.reject(error);
  }
);

export default newRequest;
